'use client';

import { Container } from 'react-bootstrap';
import type { PortableTextBlock } from 'next-sanity';

import Button from '@/componentv2/button/button';
import FontAwesomeIcon from '@/componentv2/fontAwesomeIcon/fontAwesomeIcon';
import { LandingPortableText } from '@/components/landingPortableText/landingPortableText';
import type { LANDING_OR_PRODUCT_PAGE_QUERY_RESULT } from '@/sanity.types';
import './FooterCta.scss';

type LandingPageData = Extract<
  NonNullable<LANDING_OR_PRODUCT_PAGE_QUERY_RESULT>,
  { _type: 'landingPage' }
>;

interface FooterCtaProps {
  data: NonNullable<LandingPageData['footerCta']>;
}

export default function FooterCta({ data }: FooterCtaProps) {
  const { footerContent, ctaText, ctaLink, ctaSubtext, backgroundColor } = data;

  return (
    <section
      className="rlp-footer-cta"
      style={
        backgroundColor?.value ? { backgroundColor: backgroundColor.value } : {}
      }
    >
      <Container>
        {footerContent && (
          <div className="rlp-footer-cta-content">
            <LandingPortableText value={footerContent as PortableTextBlock[]} />
          </div>
        )}
        {ctaText && (
          <Button href={ctaLink} variant="primary">
            {ctaText}
          </Button>
        )}
        {ctaSubtext && ctaSubtext.length > 0 && (
          <ul className="rlp-footer-cta-subtext">
            {ctaSubtext.map((item) => (
              <li key={item._key}>
                <FontAwesomeIcon
                  name="fa-caret-right"
                  style="fa-solid"
                  fontSize="18px"
                />
                {item.title}
              </li>
            ))}
          </ul>
        )}
      </Container>
    </section>
  );
}
